import {
  closestCenter,
  KeyboardSensor,
  MeasuringStrategy,
  PointerSensor,
} from '@dnd-kit/core'
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable'

export const DRAG_DROP_SORT_STRATEGY = {
  grid: 'grid',
  horizontal: 'horizontal',
  vertical: 'vertical',
}

export const DRAG_DROP_DEFAULT_CONFIG = {
  activationDistance: 6,
  collisionDetection: closestCenter,
  keyboardCoordinateGetter: sortableKeyboardCoordinates,
  measuringDroppableStrategy: MeasuringStrategy.Always,
  sensors: {
    keyboard: KeyboardSensor,
    pointer: PointerSensor,
  },
}

export const DRAG_DROP_OVERLAY_DEFAULT_PROPS = { style: { cursor: 'grabbing' } }

export const DRAG_DROP_MEASURING_DEFAULT_PROPS = {
  droppable: {
    strategy: DRAG_DROP_DEFAULT_CONFIG.measuringDroppableStrategy,
  },
}

export const DRAG_DROP_INTERACTION_STYLE = {
  touchAction: 'manipulation',
  userSelect: 'none',
}

export const DRAG_DROP_DATA_ATTR = {
  isDragging: 'data-is-dragging',
  isOver: 'data-is-over',
  isSorting: 'data-is-sorting',
}

export const NO_DROP_STYLE = {
  cursor: 'no-drop',
}

export const NO_DRAG_STYLE = {
  cursor: 'default',
}

export const DEFAULT_DRAG_STYLE = {
  cursor: 'grab',
}

export const DRAGGING_STYLE = {
  cursor: 'grabbing',
}

export const DRAGGING_KEEP_IN_PLACE_STYLE = {
  opacity: 0.5,
}
